'use strict';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Plugin = require('./plugin');

module.exports = function (_Plugin) {
  _inherits(ClampZoom, _Plugin);
  /**
   * @private
   * @param {object} [options]
   * @param {number} [options.minWidth] minimum width
   * @param {number} [options.minHeight] minimum height
   * @param {number} [options.maxWidth] maximum width
   * @param {number} [options.maxHeight] maximum height
   */


  function ClampZoom(parent, options) {
    _classCallCheck(this, ClampZoom);

    var _this = _possibleConstructorReturn(this, (ClampZoom.__proto__ || Object.getPrototypeOf(ClampZoom)).call(this, parent));

    _this.minWidth = options.minWidth;
    _this.minHeight = options.minHeight;
    _this.maxWidth = options.maxWidth;
    _this.maxHeight = options.maxHeight;

    _this.clamp();

    return _this;
  }

  _createClass(ClampZoom, [{
    key: 'resize',
    value: function resize() {
      this.clamp();
    }
  }, {
    key: 'clamp',
    value: function clamp() {
      if (this.paused) {
        return;
      }

      var width = this.parent.worldScreenWidth;
      var height = this.parent.worldScreenHeight;

      if (this.minWidth && width < this.minWidth) {
        var original = this.parent.scale.x;
        this.parent.fitWidth(this.minWidth, false, false, true);
        this.parent.scale.y *= this.parent.scale.x / original;
        width = this.parent.worldScreenWidth;
        height = this.parent.worldScreenHeight;
        this.parent.emit('zoomed', {
          viewport: this.parent,
          type: 'clamp-zoom'
        });
      }

      if (this.maxWidth && width > this.maxWidth) {
        var _original = this.parent.scale.x;
        this.parent.fitWidth(this.maxWidth, false, false, true);
        this.parent.scale.y *= this.parent.scale.x / _original;
        width = this.parent.worldScreenWidth;
        height = this.parent.worldScreenHeight;
        this.parent.emit('zoomed', {
          viewport: this.parent,
          type: 'clamp-zoom'
        });
      }

      if (this.minHeight && height < this.minHeight) {
        var _original2 = this.parent.scale.y;
        this.parent.fitHeight(this.minHeight, false, false, true);
        this.parent.scale.x *= this.parent.scale.y / _original2;
        width = this.parent.worldScreenWidth;
        height = this.parent.worldScreenHeight;
        this.parent.emit('zoomed', {
          viewport: this.parent,
          type: 'clamp-zoom'
        });
      }

      if (this.maxHeight && height > this.maxHeight) {
        var _original3 = this.parent.scale.y;
        this.parent.fitHeight(this.maxHeight, false, false, true);
        this.parent.scale.x *= this.parent.scale.y / _original3;
        this.parent.emit('zoomed', {
          viewport: this.parent,
          type: 'clamp-zoom'
        });
      }
    }
  }]);

  return ClampZoom;
}(Plugin);